module.exports = __webpack_public_path__ + "static/media/taffiethule04.fc2f66ce.jpg";